import logo1 from "../../../Assets/client-logo/logo1.webp";
import logo2 from "../../../Assets/client-logo/logo2.webp";
import logo3 from "../../../Assets/client-logo/logo3.webp";
import logo4 from "../../../Assets/client-logo/logo4.webp";
import logo5 from "../../../Assets/client-logo/logo5.webp";
import logo6 from "../../../Assets/client-logo/logo6.webp";
import logo7 from "../../../Assets/client-logo/logo7.webp";
import logo8 from "../../../Assets/client-logo/logo8.webp";
import logo9 from "../../../Assets/client-logo/logo9.webp";
import logo10 from "../../../Assets/client-logo/logo10.webp";

const clientLogos = [
  { id: 1, img: logo1 },
  { id: 2, img: logo2 },
  { id: 3, img: logo3 },
  {
    id: 4,
    img: logo4,
  },
  {
    id: 5,
    img: logo5,
  },
  {
    id: 6,
    img: logo6,
  },
  {
    id: 7,
    img: logo7,
  },
  {
    id: 8,
    img: logo8,
  },
  {
    id: 9,
    img: logo9,
  },
  {
    id: 10,
    img: logo10,
  },
];

export default clientLogos;
